export default "__VITE_ASSET__Cp3TFKG8__"